import Checkbox from '../../../../../../components/Checkbox'
import DataTable, {
    Caption,
    TBody,
    THead
} from '../../../../../../components/DataTable'
import {
    ControlDivider,
    FormControl,
    LabelInline
} from '../../../../../../components/FormUtilities'
import useGet from '../../../../../../hooks/useGet'
import { storagePage } from '../../../../storage'
import { parse } from 'fter'
import Product from '../../../../../../models/Product'
import Loading from '../../../../../../components/Loading'
import { FieldApplyRCsProps } from './types'
import { ChangeEvent, useState } from 'react'
import { get } from '../../../../../../utilities/http'

export default function FieldApplyRCs({
    rcs,
    productIds,
    setProductIds
}: FieldApplyRCsProps) {
    const company_id = storagePage.logistical_declaration.company_id
    const [selectedRCIds, setSelectedRCIds] = useState<number[]>(() =>
        rcs.map(rc => rc.reception_id)
    )

    const queries = parse(
        {
            reception_ids: selectedRCIds
        },
        `/v5.6/apis/companies/${company_id}/receptions/products`
    )
    const { data, loading } = useGet<Product[]>(queries, [])

    const isRCChecked = (receptionId: number) =>
        selectedRCIds.includes(receptionId)

    const isProductChecked = (productId: number) =>
        !!productIds.find(id => id === productId)

    async function handleRCCheck(ev: ChangeEvent<HTMLInputElement>) {
        const receptionId = Number(ev.target.value)
        const checked = ev.target.checked

        // Obtener productos de la RC
        const queriesRC = parse(
            {
                reception_ids: [receptionId]
            },
            `/v5.6/apis/companies/${company_id}/receptions/products`
        )
        const { data: rcData } = await get<Product[]>(queriesRC)

        if (checked) {
            // Agregar RC seleccionada
            setSelectedRCIds([...selectedRCIds, receptionId])

            // Seleccionar todos los productos de la RC
            if (rcData?.result) {
                const rcProductIds = rcData.result.map(p => p.id)
                // Agregar productos que no estén ya seleccionados
                const newProductIds = [
                    ...productIds,
                    ...rcProductIds.filter(id => !productIds.includes(id))
                ]
                setProductIds(newProductIds)
            }
        } else {
            // Remover RC seleccionada
            const newSelectedRCIds = selectedRCIds.filter(
                id => id !== receptionId
            )
            setSelectedRCIds(newSelectedRCIds)

            // Deseleccionar todos los productos de la RC deseleccionada
            if (rcData?.result) {
                const rcProductIds = rcData.result.map(p => p.id)
                setProductIds(
                    productIds.filter(id => !rcProductIds.includes(id))
                )
            }
        }
    }

    function handleProductCheck(ev: ChangeEvent<HTMLInputElement>) {
        const productId = Number(ev.target.value)
        if (isProductChecked(productId)) {
            setProductIds(productIds.filter(id => id !== productId))
        } else {
            setProductIds([...productIds, productId])
        }
    }

    return (
        <>
            <FormControl label="Aplicar a RCs" required>
                <ControlDivider divider="3">
                    {rcs.map(rc => (
                        <LabelInline label={rc.reception.code} key={rc.id}>
                            <Checkbox
                                value={rc.reception_id}
                                checked={isRCChecked(rc.reception_id)}
                                onChange={handleRCCheck}
                            />
                        </LabelInline>
                    ))}
                </ControlDivider>
            </FormControl>
            <DataTable scrollHeight={400}>
                <THead>
                    <tr>
                        <th>Productos a costear</th>
                        <th />
                    </tr>
                </THead>
                <TBody>
                    {data.result.map(product => (
                        <tr key={product.id}>
                            <td>{product.description}</td>
                            <td>
                                <Checkbox
                                    value={product.id}
                                    checked={isProductChecked(product.id)}
                                    onChange={handleProductCheck}
                                />
                            </td>
                        </tr>
                    ))}
                    {data.result.length === 0 && !loading && (
                        <Caption colSpan={2}>No hay productos</Caption>
                    )}
                    {loading && (
                        <Caption colSpan={2}>
                            <Loading height="auto" scale={0.8} />
                        </Caption>
                    )}
                </TBody>
            </DataTable>
        </>
    )
}
